import { tableStyles } from "./styles";
import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      ...tableStyles.tableList,
      padding: "10px 6px",
      "&:hover": {
        background: Colors.BLUE100_1,
      },
    },
  },
  variants: [
    {
      props: { variant: "select" },
      style: {
        "&.child": {
          paddingLeft: "20px",
        },
      },
    },
    {
      props: {variant: "placeholder"},
      style: {
        ...tableStyles.tableHeader
      }
    }
  ],
};
